import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { money, pct, respTime } from './TimeframeSelect';

const COLS = [
  ['Chatter', null], ['Messages', 'messages'], ['PPV sent', 'ppvs_sent'], ['Unlocked', 'ppvs_unlocked'],
  ['Conv.', null], ['PPV $', 'ppvRevenue'], ['Tips $', 'tipsRevenue'], ['Chargebacks', 'chargebackAmount'],
  ['Sales', 'sales'], ['Earnings', 'earnings'], ['Hours', 'active_hours'], ['Resp.', null],
];

export const ChattersTable = ({ chatters, showEarnings = true }) => {
  const cols = showEarnings ? COLS : COLS.filter(c => c[1] !== 'earnings');
  if (!chatters?.length) {
    return <div className="p-6 text-center text-zinc-500 bg-card rounded-md border border-border" data-testid="chatters-table-empty">No chatter activity for this period</div>;
  }
  return (
    <div className="bg-card rounded-md border border-border overflow-x-auto" data-testid="chatters-table">
      <Table>
        <TableHeader>
          <TableRow className="border-zinc-800">
            {cols.map(([l]) => <TableHead key={l} className="text-xs uppercase tracking-wider text-zinc-400 whitespace-nowrap">{l}</TableHead>)}
          </TableRow>
        </TableHeader>
        <TableBody>
          {chatters.map(c => (
            <TableRow key={c.chatter_uuid} className="border-zinc-800" data-testid={`chatter-row-${c.chatter_uuid}`}>
              <TableCell className="text-white font-medium whitespace-nowrap">
                {c.chatter_name}
                {c.va_name && <div className="text-xs text-zinc-500">{c.va_name}</div>}
                {!c.is_current_member && <div className="text-xs text-amber-500">Left agency</div>}
              </TableCell>
              <TableCell className="tabular-nums text-zinc-300">{c.messages.toLocaleString()}</TableCell>
              <TableCell className="tabular-nums text-zinc-300">{c.ppvs_sent}</TableCell>
              <TableCell className="tabular-nums text-zinc-300">{c.ppvs_unlocked}</TableCell>
              <TableCell className="tabular-nums text-zinc-300">{pct(c.unlock_ratio)}</TableCell>
              <TableCell className="tabular-nums text-zinc-300">{money(c.ppvRevenue)}</TableCell>
              <TableCell className="tabular-nums text-zinc-300">{money(c.tipsRevenue)}</TableCell>
              <TableCell className="tabular-nums text-red-400">{c.chargebackAmount ? `−${money(c.chargebackAmount)}` : '—'}</TableCell>
              <TableCell className="tabular-nums text-white font-semibold">{money(c.sales)}</TableCell>
              {showEarnings && <TableCell className="tabular-nums text-green-500">{money(c.earnings)}</TableCell>}
              <TableCell className="tabular-nums text-zinc-300">{c.active_hours.toFixed(1)}</TableCell>
              <TableCell className="tabular-nums text-zinc-300">{respTime(c.avg_response_ms)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
